'use strict';

/* @ngInject */
export default class ConfirmDeleteSubObjectController {
  constructor($uibModalInstance, okFunction) {
    this.$uibModalInstance = $uibModalInstance;
    this.okFunction = okFunction;
    this.name = '';
  }

  cancel() {
    this.$uibModalInstance.close();
  };
  deleteAndKeep() {
    this.$uibModalInstance.close();
    this.okFunction(true);
  };

  delete() {
    this.$uibModalInstance.close();
    this.okFunction(false);
  };
}